/*
* 消息推送管理
* */
export const GETPUSHLIST = 'GETPUSHLIST'
export const PUSHUPDATESTATUS = 'PUSHUPDATESTATUS'



// WEBPACK FOOTER //
// ./src/store/pushMessage/types.js